// extracted by mini-css-extract-plugin
export default {"screen":"NotFoundPage_screen__GXMyA","content":"NotFoundPage_content__4jcxa"};